import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  Button,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import useTranslation from '../../../hooks/useTranslation';

const ShippingLocationModal = ({ open, onClose, onSave, fulfillmentCenters, initialData }) => {
  const { t } = useTranslation();

  const [mode, setMode] = useState('custom');
  const [customLocation, setCustomLocation] = useState(initialData || { name: '', address: '' });
  const [selectedCenterId, setSelectedCenterId] = useState('');

  useEffect(() => {
    if (mode === 'fulfillment_center' && initialData?.fulfillment_center_id) {
      setSelectedCenterId(initialData.fulfillment_center_id);
    }
  }, [mode, initialData]);

  const handleSave = () => {
    if (mode === 'custom') {
      onSave(customLocation);
    } else {
      const selectedCenter = fulfillmentCenters.find((center) => center.id === selectedCenterId);
      onSave({
        name: selectedCenter?.name || '',
        address: selectedCenter?.address || '',
        fulfillment_center_id: selectedCenterId,
      });
    }
  };

  return (
    <Modal open={open} onClose={onClose} aria-labelledby="shipping-location-modal">
      <div style={{ padding: 20, maxWidth: 600, margin: '50px auto', backgroundColor: 'white', borderRadius: 8 }}>
        <Typography variant="h6">{t('labels.shipping_profile.manage_location')}</Typography>
        <FormControl fullWidth margin="normal">
          <InputLabel>{t('labels.shipping_profile.location_mode')}</InputLabel>
          <Select value={mode} onChange={(e) => setMode(e.target.value)}>
            <MenuItem value="custom">{t('labels.shipping_profile.custom_location')}</MenuItem>
            <MenuItem value="fulfillment_center">{t('labels.shipping_profile.use_fulfillment_center')}</MenuItem>
          </Select>
        </FormControl>

        {mode === 'custom' ? (
          <>
            <TextField
              label={t('labels.shipping_profile.location_name')}
              value={customLocation.name}
              onChange={(e) => setCustomLocation({ ...customLocation, name: e.target.value })}
              fullWidth
              margin="normal"
            />
            <TextField
              label={t('labels.shipping_profile.location_address')}
              value={customLocation.address}
              onChange={(e) => setCustomLocation({ ...customLocation, address: e.target.value })}
              fullWidth
              margin="normal"
            />
          </>
        ) : (
          <FormControl fullWidth margin="normal">
            <InputLabel>{t('labels.shipping_profile.select_fulfillment_center')}</InputLabel>
            <Select
              value={selectedCenterId}
              onChange={(e) => setSelectedCenterId(e.target.value)}
            >
              {fulfillmentCenters.map((center) => (
                <MenuItem key={center.id} value={center.id}>
                  {center.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        <div style={{ marginTop: 20, display: 'flex', justifyContent: 'space-between' }}>
          <Button variant="outlined" onClick={onClose}>
            {t('labels.shipping_profile.cancel')}
          </Button>
          <Button variant="contained" color="primary" onClick={handleSave}>
            {t('labels.shipping_profile.save')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

ShippingLocationModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  fulfillmentCenters: PropTypes.array.isRequired,
  initialData: PropTypes.object,
};

export default ShippingLocationModal;